// The chat feature (web-chat, p1h-web-5d): ask a project's deployed `rag` agents, in the Work
// group and the palette.
import { MessagesSquareIcon } from "lucide-react";
import { registerCommand } from "../../app/registry/commands";
import { type NavLocation, registerNav } from "../../app/registry/nav";
import { routes } from "../context";

const chatOf = ({ params, search }: NavLocation) => {
  const project =
    params.project ?? (typeof search.project === "string" ? search.project : undefined);
  return params.workspace && project ? routes.chat(params.workspace, project) : null;
};

registerNav({
  id: "chat",
  group: "work",
  labelKey: "chat.nav",
  icon: MessagesSquareIcon,
  to: chatOf,
  order: 10,
});
registerCommand({
  id: "chat",
  group: "palette.groups.actions",
  labelKey: "chat.command",
  icon: MessagesSquareIcon,
  keywords: ["chat", "ask", "question", "rag", "discussion", "poser"],
  to: chatOf,
});
